// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/download-payment-status-report-request-schema',
  type: 'object',
  required: [],
  properties: {
    redebitIds: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
  },
} as IJSONSchema;

export default schema;
